import { FC } from "react";
import { InfoList, Section } from "@landtechnologies/components";

import { MeasurementSystem } from "src/js/stores/user/store";
import { SupportedLocale } from "src/js/util/dates";

import { RecordType, ZooplaField } from "../../../typings";
import { ZooplaSection } from "./ZooplaSection";
import { LandTechSection } from "./LandTechSection";
import { useTranslation } from "react-migration/lib";
import { hasFeature } from "src/js/stores/user/actions";
import { Feature } from "src/js/stores/user";
import { ZooplaListingsFromUPRN } from "./ZooplaListings/ZooplaListingsFromUPRN";

export interface RecordProps {
  record: RecordType;
  unitPreference: MeasurementSystem;
  locale: SupportedLocale;
  zooplaData?: ZooplaField[];
  zooplaDataLoading?: boolean;
}

export const Record: FC<RecordProps> = ({
  locale,
  record,
  unitPreference,
  zooplaData,
  zooplaDataLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Section data-testid="record">
      <InfoList>
        <InfoList.Item data-testid="record-item">
          <InfoList.ItemTitle>
            <div className="atlas-flex">
              <div className="atlas-grow">
                {record.address.split(", ").map((line: string) => (
                  <div key={line} className="atlas-text-xs sm:atlas-text-sm">
                    {line}
                  </div>
                ))}
              </div>
              <ZooplaListingsFromUPRN uprn={record.uprn} className="atlas-ml-1" />
            </div>
          </InfoList.ItemTitle>
        </InfoList.Item>

        <ZooplaSection data={zooplaData} loading={zooplaDataLoading} />
        <LandTechSection record={record} unitPreference={unitPreference} locale={locale} />
        {!hasFeature(Feature.usAccess) && (
          <div className="atlas-p-1">
            <span className="atlas-text-neutral-500 atlas-mx-1">
              {t("comparables.map.sidebar.value.record.source")}
            </span>
            <span className="atlas-font-semibold atlas-text-neutral-500 atlas-mx-1">
              {t("comparables.map.sidebar.value.record.sources")}
            </span>
          </div>
        )}
      </InfoList>
    </Section>
  );
};
